<template>
    <div
        class="help-modal"
        role="tooltip"
    >
        <CmsBlocks
            :data="blocks"
            page-type="questionnaire"
        />

        <header class="header">
            <ButtonRound
                class="button-close"
                icon="close"
                type="link"
                aria-label="Close help modal"
                @click="$emit('close-help-modal')"
            />
        </header>
    </div>
</template>

<script setup lang="ts">
import type { BlockFragment } from '@/graphql/api'

import ButtonRound from '@/components/ui/buttons/ButtonRound.vue'
import CmsBlocks from '@/components/cms/CmsBlocks.vue'

defineProps<{
    blocks: BlockFragment[]
}>()

defineEmits<{
    'close-help-modal': []
}>()
</script>

<style lang="scss" scoped>
.help-modal {
    --bar-height: 70px;

    background-color: var(--stone-3);
    position: absolute;
    inset: 0;
    padding: var(--bar-height) 0;

    @include min-width(1024) {
        --bar-height: 80px;
    }

    .header {
        position: absolute;
        top: 0;
        width: 100%;
        height: var(--bar-height);
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}
</style>
